module.exports = __webpack_public_path__ + "static/72-40aee93e8e009079a5267bc370411560.png";